import React from "react";
import { Accordion } from "react-bootstrap";
import { __ } from "services/Translator";
import { getBonusIconMeta } from "utils/getBonusIcon";

function plainCampaignText(value) {
  if (!value) return null;
  const text = String(value)
    .replace(/<[^>]*>/g, " ")
    .replace(/\s+/g, " ")
    .trim();
  return text || null;
}

function getSummaryText({ isCampaignsLoading, selectedBonus, isNoBonusSelected }) {
  if (isCampaignsLoading) return __("Loading offers...");
  if (selectedBonus) return selectedBonus.title;
  if (isNoBonusSelected) return __("No bonus");
  return __("Tap to choose an offer");
}

function Option({ active, onSelect, title, subtitle, imageSrc, imageFallback }) {
  return (
    <button
      type="button"
      className={`gcc-bonus-option ${active ? "is-selected" : ""}`}
      onClick={onSelect}
      aria-pressed={active}
    >
      <span className="gcc-bonus-option__radio" aria-hidden="true" />
      <span className="gcc-bonus-option__text">
        <span className="gcc-bonus-option__title">{title}</span>
        {subtitle ? <span className="gcc-bonus-option__sub">{subtitle}</span> : null}
      </span>
      {imageSrc ? (
        <img
          src={imageSrc}
          alt=""
          className={
            "gcc-bonus-option__thumb " + (imageFallback ? "gcc-bonus-option__thumb--icon" : "")
          }
        />
      ) : null}
    </button>
  );
}

export default function SignupBonusAccordion({
  campaigns,
  isCampaignsLoading,
  bonusOffer,
  onSelectBonus,
  activeKey,
  onAccordionSelect,
}) {
  const selectedBonus = campaigns.find((item) => item.id === bonusOffer) || null;
  const isNoBonusSelected = bonusOffer === "no_bonus";
  const accordionKey = "bonus-offers";
  const isOpen = activeKey === accordionKey;
  const summary = getSummaryText({ isCampaignsLoading, selectedBonus, isNoBonusSelected });

  return (
    <div className="gcc-bonus-simple">
      <p className="gcc-bonus-simple__label">{__("Welcome bonus")}</p>

      <Accordion
        className="gcc-bonus-simple__accordion"
        activeKey={activeKey}
        onSelect={onAccordionSelect}
      >
        <Accordion.Item eventKey={accordionKey}>
          <Accordion.Header>
            <span className="gcc-bonus-simple__trigger">
              <span className="gcc-bonus-simple__summary">{summary}</span>
              <i
                className={
                  "fas fa-chevron-down gcc-bonus-simple__arrow" +
                  (isOpen ? " gcc-bonus-simple__arrow--up" : "")
                }
                aria-hidden="true"
              />
            </span>
          </Accordion.Header>

          <Accordion.Body>
            <div className="gcc-bonus-simple__options">
              {isCampaignsLoading &&
                [0, 1].map((i) => (
                  <div key={i} className="gcc-bonus-option gcc-bonus-option--loading" aria-hidden="true">
                    <span className="gcc-bonus-option__radio" />
                    <span className="gcc-bonus-option__text">
                      <span className="gcc-bonus-option__bar" />
                      <span className="gcc-bonus-option__bar gcc-bonus-option__bar--short" />
                    </span>
                  </div>
                ))}

              {!isCampaignsLoading &&
                campaigns.map((item) => {
                  const icon = getBonusIconMeta(item);
                  return (
                    <Option
                      key={item.id}
                      active={bonusOffer === item.id}
                      onSelect={() => onSelectBonus(item.id)}
                      title={item.title}
                      subtitle={plainCampaignText(item.campaign_information)}
                      imageSrc={icon.src}
                      imageFallback={icon.isFallback}
                    />
                  );
                })}

              {!isCampaignsLoading && (
                <Option
                  active={isNoBonusSelected}
                  onSelect={() => onSelectBonus("no_bonus")}
                  title={__("No bonus")}
                  subtitle={__("Continue without an offer")}
                />
              )}
            </div>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
}
